import React, { useState } from 'react';
import { theme, Switcher, Flex, SettingsIcon } from '@kvdbil/components';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { environment } from '~/config/public';
import { useOnMount } from '~/App/shared/hooks/useOnMount';

const DebugWrapper = styled.div<{ show: boolean }>`
  color: ${theme.colors.grayscaleToned.dark4};
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0.5rem;
  background-color: ${theme.colors.grayscaleToned.light5};
  border-top: 2px solid ${theme.colors.grayscaleToned.light3};
  width: 100%;
  transform: ${({ show }) => `translateY(${show ? 0 : '100%'})`};
  transition: 0.3s;
  z-index: 3;
`;

const IconWrapper = styled.button`
  border-top: 2px solid ${theme.colors.grayscaleToned.light3};
  border-left: 2px solid ${theme.colors.grayscaleToned.light3};
  border-right: 2px solid ${theme.colors.grayscaleToned.light3};
  width: 2.5rem;
  height: 2.5rem;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
  margin-top: -3rem;
  background-color: ${theme.colors.grayscaleToned.light5};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const ContentWrapper = styled.div`
  padding-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Version = styled.span`
  font-size: 0.75rem;
  font-weight: ${theme.typography.fontBaseBoldWeight};
`;

const DebugBar = () => {
  const { setShowKeys, options } = useTranslation();
  const [show, setShow] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useOnMount(() => setIsMounted(true));

  if (!isMounted) {
    return null;
  }

  return (
    <DebugWrapper show={show}>
      <IconWrapper onClick={() => setShow(s => !s)}>
        <SettingsIcon />
      </IconWrapper>
      <ContentWrapper>
        <Flex>
          <Switcher
            color="info"
            selected={options?.showKeys}
            onToggle={() => {
              setShowKeys(s => !s);
            }}
          />
          <span>Show keys</span>
        </Flex>
        {environment.version && <Version>{environment.version}</Version>}
      </ContentWrapper>
    </DebugWrapper>
  );
};

export default DebugBar;
